// services/city.service.ts

import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private apiUrl = eps.auth.stateApi
  constructor(private http: HttpClient) {}

  getStatesByCountry(countryId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`)
  }

  //   getStateById(stateId: string): Observable<CityCountryState> {
  //     return this.http.get<CityCountryState>(`${this.apiUrl}/${stateId}`)
  //   }
}
